// TODO (webpack v5): drop the `build/package/` part of these import paths.
// Snabbdom>=1 uses the package.json#exports field that webpack v4 doesn't know
// about
//
// https://github.com/webpack/webpack/issues/9509
// https://webpack.js.org/guides/package-exports/
import {signingH} from 'snabbdom-signature';
import {h as unsignedH} from 'snabbdom/build/package/h';
import {formatProps, validateProps, flat, formatChildren} from './utils';

const signedH = signingH(unsignedH);

/**
 * Creates an element for the virtual DOM
 * @method createElement
 * @param {(string|function)} tag Name of the tag or a functional component
 * @param {object} [props] Properties
 * @param {object} [children] Child nodes
 * @returns {*}
 */
export default function createElement(tag, props, ...children) {
	if (typeof tag === 'function') return tag(props || {}, flat(children));

	return signedH(
		tag,
		props ? formatProps(tag, validateProps(props)) : {},
		formatChildren(children)
	);
}
